import script from "./NavigationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationView.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationView.vue?vue&type=style&index=0&id=145ff7e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-145ff7e1"]])

export default __exports__